import { Command } from "./Command";
import { HistoryEventHandler } from "../history";

/**
 * History command for an element that had its DOM position changed.
 * @implements {module:history.HistoryCommand}
*/
export class MoveElementCommand extends Command {
    public oldNextSibling: Element;
    public oldParent: Element;
    public newNextSibling: Element;
    public newParent: Element;

    /**
    * @param {SVGElement} elem - The DOM element that was moved
    * @param {Element} oldNextSibling - The element's next sibling before it was moved
    * @param {Element} oldParent - The element's parent before it was moved
    * @param {string} [text] - An optional string visible to user related to this change
    */
    constructor(elem: SVGElement, oldNextSibling: Element, oldParent: Element, text?: string) {
        super();

        this.elem = elem;
        this.text = text ? ('Move ' + elem.tagName + ' to ' + text) : ('Move ' + elem.tagName);
        this.oldNextSibling = oldNextSibling;
        this.oldParent = oldParent;
        this.newNextSibling = elem.nextSibling as Element;
        this.newParent = elem.parentNode as Element;
    }

    /**
     * Re-positions the element.
     * @param {module:history.HistoryEventHandler} handler
     * @fires module:history~Command#event:history
     * @returns {void}
    */
    apply(handler: HistoryEventHandler) {
        super.apply(handler, () => {
            this.elem = this.newParent.insertBefore(this.elem, this.newNextSibling);
        });
    }

    /**
     * Positions the element back to its original location.
     * @param {module:history.HistoryEventHandler} handler
     * @fires module:history~Command#event:history
     * @returns {void}
    */
    unapply(handler: HistoryEventHandler) {
        super.unapply(handler, () => {
            this.elem = this.oldParent.insertBefore(this.elem, this.oldNextSibling);
        });
    }
}
